/**
 * Learn from Leaders 1003 — centered title/description over an optional
 * full-bleed background image, with a row of leader cards (photo, name, bio,
 * up to two company logos). Migrated from the Chandigarh Leadership organism.
 */
export const LFL_1003_DEFAULT_TITLE = "Learn From {Leaders}";
export const LFL_1003_DEFAULT_TITLE_COLOR = "#171719";
export const LFL_1003_DEFAULT_TITLE_ACCENT_COLOR = "#E1473F";
export const LFL_1003_DEFAULT_DESCRIPTION_COLOR = "#171719";
export const LFL_1003_DEFAULT_CTA_COLOR = "#E1473F";
export const LFL_1003_DEFAULT_CTA_TEXT_COLOR = "#FFFFFF";

export const LEARN_FROM_LEADERS_1003_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Leader cards",
  },

  DEFAULT_ROW: {
    id: "",
    profile_name: "",
    profile_title: "",
    desktop_image: "",
    image_alt: "",
    logo_1: "",
    logo_1_alt: "",
    logo_2: "",
    logo_2_alt: "",
    priority: 0,
    is_active: true,
  },

  LEARN_FROM_LEADERS_1003_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: LFL_1003_DEFAULT_TITLE,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Use {curly braces} to highlight words",
      required: true,
      defaultValue: LFL_1003_DEFAULT_TITLE,
    },
    {
      fieldName: "title_start_color",
      label: "Title text color",
      value: LFL_1003_DEFAULT_TITLE_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_1003_DEFAULT_TITLE_COLOR,
    },
    {
      fieldName: "title_end_color",
      label: "Title highlight color",
      value: LFL_1003_DEFAULT_TITLE_ACCENT_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_1003_DEFAULT_TITLE_ACCENT_COLOR,
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Body copy below the title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description text color",
      value: LFL_1003_DEFAULT_DESCRIPTION_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_1003_DEFAULT_DESCRIPTION_COLOR,
    },
    {
      fieldName: "cta_text",
      label: "CTA button text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty to hide the button",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_color",
      label: "CTA button color",
      value: LFL_1003_DEFAULT_CTA_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_1003_DEFAULT_CTA_COLOR,
    },
    {
      fieldName: "cta_text_color",
      label: "CTA button text color",
      value: LFL_1003_DEFAULT_CTA_TEXT_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_1003_DEFAULT_CTA_TEXT_COLOR,
    },
    {
      fieldName: "background_image",
      label: "Background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_image_alt",
      label: "Background image alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Name",
      fieldName: "profile_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leader name",
      required: true,
    },
    {
      header: "Title / bio",
      fieldName: "profile_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Role or short bio",
      required: false,
    },
    {
      header: "Photo",
      fieldName: "desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Photo alt",
      fieldName: "image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Company logo 1",
      fieldName: "logo_1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Company logo 1 alt",
      fieldName: "logo_1_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Company logo 2",
      fieldName: "logo_2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Company logo 2 alt",
      fieldName: "logo_2_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Active",
      fieldName: "is_active",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
    },
  ],
};
